<mat-expansion-panel *ngIf="isSmallScreen||mobileCardView"
                     (click)="$event.stopPropagation();openTab('details')"
                     class="expansion-card custom-expansion-body custom-expansion-indicator"
                     #expansionPanel>

  <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'" style="padding: 12px 16px">

    <div style="display: flex; flex-direction: column; flex-grow: 1">
      <div style="display: flex; flex-direction: row; gap: 12px; margin-bottom: 12px; align-items: center">
        <button mat-icon-button (click)="$event.stopPropagation(); starClicked()">
          <mat-icon [ngStyle]="isFavorite ? { 'color': 'gold' } : {}">
            {{ isFavorite ? 'star' : 'star_border' }}
          </mat-icon>
        </button>
        <div style="height: 48px; width: 40px; display: flex; align-items: center; justify-content: flex-start;">
          <mat-icon fontSet="material-symbols-outlined" style="color: var(--mat-sys-outline)">
            {{icon}}
          </mat-icon>
        </div>
        <span class="example-spacer"></span>
        <button mat-mini-fab matTooltip="{{'ATTACHMENTS' | translate}}"
                matBadge="{{countAttachments()}}"
                aria-hidden="false" matBadgeDisabled="{{countAttachments()===0}}"
                (click)="$event.stopPropagation(); openTab('attachments')">
          <mat-icon>attach_file</mat-icon>
        </button>
        <button mat-mini-fab matTooltip="{{'COMMENTS' | translate}}"
                matBadge="{{countMessages()}}"
                [matBadgeHidden]="countMessages()===0"
                aria-hidden="false"
                (click)="$event.stopPropagation(); openTab('comments')"
                [disabled]="countMessages()===0">
          <mat-icon>question_answer</mat-icon>
        </button>
        <button mat-mini-fab [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"><mat-icon>more_vert</mat-icon></button>
      </div>
      <div style="display: flex; flex-direction: column; margin-bottom: 12px">
        <span>{{subject}} <span *ngIf="type==='WfTask'" class="reference-number">#{{referenceNumber}}</span></span>
        <span class="subtitle-style accent-color">{{taskName}}</span>
        <span *ngIf="type==='Task'" class="subtitle-style lightgrey-color">#{{referenceNumber}}</span>
      </div>
      <div style="display: flex; flex-direction: column; margin-bottom: 24px; min-height: 48px;" class="label-style"
           *ngIf="previewMetaItems.length>0||mobileCardView">
        <span *ngFor="let item of previewMetaItems"
              class="preview-meta-item"
              [class.preview-meta-item--multiline]="item.type === 'Textarea'">
          <span class="highlighted-text">{{item.name}}: </span>{{item.humanvalue || item.value || '-'}}
        </span>
      </div>
      <div style="display: flex; align-items: center; justify-content: flex-start; flex-direction: row; gap: 6px; margin: 12px 0"
           [matTooltip]="deadlineTooltip"
           matTooltipPosition="above"
           class="subtitle-style"
           [ngClass]="{
           'warning-color-deadline': ((deadlineCounter === missedDeadline)&&isActiveStatus()),
           'accent-color': ((deadlineCounter !== missedDeadline)&&isActiveStatus()),
           'draft-color': isDraftStatus(),
           'closed-color': (!isActiveStatus() && !isDraftStatus())}">
        <mat-icon *ngIf="isActiveStatus()" fontSet="material-symbols-outlined">alarm</mat-icon>
        <mat-icon *ngIf="isDraftStatus()" fontSet="material-symbols-outlined">error</mat-icon>
        <mat-icon *ngIf="!isActiveStatus() && !isDraftStatus()">check_circle</mat-icon>
        <span>{{isActiveStatus() ? deadlineCounter : (isDraftStatus() ? draft : closed)}}</span>
      </div>
      <div style="display: flex; flex-flow: row wrap; margin-top: 12px; align-items: center; gap: 12px">
        <mat-form-field subscriptSizing="dynamic" *ngIf="isActiveStatus()" (click)="$event.stopPropagation()"
                        style="min-width:260px; flex-grow: 1; max-width: 375px;">
          <mat-label>{{'RESULT' | translate}}</mat-label>
          <mat-select placeholder="{{'NOT_SELECTED' | translate}}"
                      disableOptionCentering="true"
                      [(ngModel)]="selectedResult" (selectionChange)="setCommentState()">
            <mat-option *ngFor="let option of possibleTaskResultsSorting()"
                        [value]="option">
              {{option.displayName}}
            </mat-option>
          </mat-select>
          <!-- <mat-hint *ngIf="missingComment&&isMandatoryComment()">
            *{{ 'MANDATORY_COMMENT' | translate }}
          </mat-hint> -->
        </mat-form-field>
<!--        <app-meta-data-onlyread *ngIf="!isActiveStatus()"-->
<!--                                [value]="result ? result : ''"-->
<!--                                [title]="'RESULT' | translate">-->
<!--        </app-meta-data-onlyread>-->
        <button mat-flat-button style="margin-left: auto" *ngIf="isActiveStatus()"
                [disabled]="!isResult()" (click)="$event.stopPropagation();completeTask()">
          <mat-icon>send</mat-icon>
          {{'SEND' | translate}}
        </button>
      </div>
    </div>
  </mat-expansion-panel-header>
</mat-expansion-panel>

<mat-expansion-panel *ngIf="!isSmallScreen&&!mobileCardView"
                     (click)="$event.stopPropagation();this.openTab('details')"
                     class="expansion-card custom-expansion-body"
                     #expansionPanel>

  <mat-expansion-panel-header style="padding: 0 16px" collapsedHeight="76px" expandedHeight="76px">
    <div style="flex: 1; display: flex; align-items: center; justify-content: flex-start; gap: 12px">
      <button mat-icon-button (click)="$event.stopPropagation(); starClicked()">
        <mat-icon [ngStyle]="isFavorite ? { 'color': 'gold' } : {}">
          {{ isFavorite ? 'star' : 'star_border' }}
        </mat-icon>
      </button>
      <div style="width: 48px; height: 48px; display: flex; align-items: center">
        <mat-icon fontSet="material-symbols-outlined" style="color: var(--mat-sys-outline)">
          {{icon}}
        </mat-icon>
      </div>
      <div style="display: flex; flex-direction: row; align-items: center; flex-grow: 1">
        <div style="flex:1;display: flex; flex-direction: column; max-height: 68px; overflow-x: auto; scrollbar-width: thin">
          <span>{{subject}} <span *ngIf="type==='WfTask'" class="reference-number">#{{referenceNumber}}</span></span>
          <span class="subtitle-style accent-color">{{taskName}}</span>
          <span *ngIf="type==='Task'" class="subtitle-style lightgrey-color">#{{referenceNumber}}</span>
        </div>
        <div style="flex:1;display: flex; flex-direction: column; max-height: 64px; overflow-x: auto; scrollbar-width: thin"
             class="label-style">
        <span *ngFor="let item of previewMetaItems"
              class="preview-meta-item"
              [class.preview-meta-item--multiline]="item.type === 'Textarea'">
          <span class="highlighted-text">{{item.name}}: </span>{{item.humanvalue || item.value || '-'}}
        </span>
        </div>
      </div>
    </div>
    <div style="flex: 1; display: flex; align-items: center; justify-content: flex-end; gap: 12px">
      <div style="display: flex; align-items: center; justify-content: flex-start; flex-direction: row; gap: 6px"
           [matTooltip]="deadlineTooltip"
           matTooltipPosition="above"
           class="subtitle-style"
           [ngClass]="{
             'warning-color-deadline': ((deadlineCounter === missedDeadline)&&isActiveStatus()),
             'accent-color': ((deadlineCounter !== missedDeadline)&&isActiveStatus()),
             'draft-color': isDraftStatus(),
             'closed-color': (!isActiveStatus() && !isDraftStatus())}">
        <mat-icon *ngIf="isActiveStatus()" fontSet="material-symbols-outlined">alarm</mat-icon>
        <mat-icon *ngIf="isDraftStatus()" fontSet="material-symbols-outlined">error</mat-icon>
        <mat-icon *ngIf="!isActiveStatus() && !isDraftStatus()">check_circle</mat-icon>
        <span style="width: 60px; word-break: break-word">
            {{isActiveStatus() ? deadlineCounter : (isDraftStatus() ? draft : closed)}}
        </span>
      </div>
      <div style="width: 250px">
        <mat-form-field subscriptSizing="dynamic" *ngIf="isActiveStatus()" (click)="$event.stopPropagation()" style="width: 250px">
          <mat-label>{{'RESULT' | translate}}</mat-label>
          <mat-select placeholder="{{'NOT_SELECTED' | translate}}"
                      disableOptionCentering="true"
                      [(ngModel)]="selectedResult" (selectionChange)="setCommentState()">
            <mat-option *ngFor="let option of possibleTaskResultsSorting()"
                        [value]="option">
              {{option.displayName}}
            </mat-option>
          </mat-select>
          <!-- <mat-hint *ngIf="missingComment&&isMandatoryComment()">
            *{{ 'MANDATORY_COMMENT' | translate }}
          </mat-hint> -->
        </mat-form-field>
      </div>
<!--      <app-meta-data-onlyread *ngIf="!isActiveStatus()"-->
<!--                              [value]="result ? result : ''"-->
<!--                              [title]="'RESULT' | translate">-->
<!--      </app-meta-data-onlyread>-->
      <div style="width: 105px">
        <button mat-flat-button *ngIf="isActiveStatus()"
                [disabled]="!isResult()" (click)="$event.stopPropagation();completeTask()">
          <mat-icon>send</mat-icon>
          {{'SEND' | translate}}
        </button>
      </div>
      <button mat-mini-fab matTooltip="{{'ATTACHMENTS' | translate}}"
              matBadge="{{countAttachments()}}"
              aria-hidden="false" matBadgeDisabled="{{countAttachments()===0}}"
              (click)="$event.stopPropagation(); openTab('attachments')">
        <mat-icon>attach_file</mat-icon>
      </button>
      <button mat-mini-fab matTooltip="{{'COMMENTS' | translate}}"
              matBadge="{{countMessages()}}"
              [matBadgeHidden]="countMessages()===0"
              aria-hidden="false"
              (click)="$event.stopPropagation(); openTab('comments')"
              [disabled]="countMessages()===0">
        <mat-icon>question_answer</mat-icon>
      </button>
      <button style="margin-right: 12px" mat-mini-fab [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"><mat-icon>more_vert</mat-icon></button>
    </div>
  </mat-expansion-panel-header>
</mat-expansion-panel>
<mat-menu #menu="matMenu" xPosition="before">
  <button mat-menu-item (click)="onForwardTask()" [disabled]="!isActiveStatus()">
    <mat-icon>forward</mat-icon>
    <span>{{'FORWARD' | translate}}</span>
  </button>
  <button mat-menu-item (click)="onDetails()" *ngIf="type==='WfTask'">
    <mat-icon>info</mat-icon>
    <span>Workflow infók</span>
  </button>
  <button mat-menu-item *ngIf="type==='WfTask'" (click)="openDigraphDiagram()">
    <mat-icon>account_tree</mat-icon>
    <span>Workflow sablon diagram</span>
  </button>
</mat-menu>
